module.exports = __webpack_public_path__ + "img/bootstrap4-light-purple.ac5da601.svg";